<template>
  <div id="app">
    <div class="header-box" v-if="isHeaderShow">
      <headerSystem></headerSystem>
      <headerMessageCenter></headerMessageCenter>
    </div>
    <router-view v-if="isRouterAlive"/>
  </div>
</template>

<script>
import headerSystem from "@/components/headerSystem";
import headerMessageCenter from "@/components/headerMessageCenter";

export default {
  name: "App",
  
provide () {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true
    };
  },
  mounted() {
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function() {
         this.isRouterAlive = true
      })
    }
  },
  components: {
    headerSystem,
    headerMessageCenter
  },
  computed: {
    isHeaderShow: function() {
      let boolean = this.$route.path === "/login" ? false : true;
      return boolean;
    }
  }
};
</script>

<style lang="scss">
html,
body {
  width: 100%;
  height: 100%;
  min-width: 1280px;
  padding-right: 0px !important;
  background: #fff;
  overflow-y: hidden;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
  /* margin-top: 60px; */
}

.avatar-uploader input[type="file"] {
  display: none !important;
}
.header-box{
  position: fixed;
  z-index: 3;
  width: 100%;
}
.el-message {
  top: 30%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue